export const industries = {
  breadcrumb: {
    home: 'Home',
    industries: 'Industries',
  },
  hero: {
    title: 'Industries We Serve',
    subtitle: 'Delivering specialized filtration and purification solutions across multiple sectors with proven expertise and technical excellence',
  },
  grid: {
    exploreSolutions: 'Explore Solutions',
  },
  detail: {
    clickToView: 'Click to view detailed solutions',
    overview: 'Overview',
    challenges: 'Industry Challenges',
    recommendedTech: 'Recommended Technologies & Products',
    successStory: 'Success Story',
    viewProducts: 'View Products',
    exploreTechnologies: 'Explore Technologies',
    requestConsultation: 'Request Consultation',
  },
  cta: {
    title: 'Cross-Industry Solutions',
    subtitle: 'Our versatile filtration technologies and custom engineering approach enable us to serve diverse industries with tailored solutions that meet specific requirements',
    requestConsultation: 'Request Industry-Specific Consultation',
  },
  items: {
    foodBeverage: {
      name: 'Food & Beverage Industry',
      description: 'Comprehensive filtration and purification solutions for food processing, beverage production, and ingredient manufacturing, ensuring product quality, safety, and regulatory compliance.',
      challenges: [
        'Maintaining product clarity and stability',
        'Meeting strict food safety regulations',
        'Preventing microbial contamination',
        'Reducing production costs',
        'Minimizing product loss',
      ],
      technologies: [
        { name: 'Microfiltration', use: 'Beverage clarification and sterilization' },
        { name: 'Ultrafiltration', use: 'Protein concentration and recovery' },
        { name: 'Depth Filtration', use: 'Wine and beer clarification' },
        { name: 'Membrane Filtration', use: 'Dairy processing and concentration' },
      ],
      caseExample: {
        title: 'Juice Production Optimization',
        result: '40% reduction in filter costs, 95% clarity improvement',
      },
    },
    foodService: {
      name: 'Food Service Filtration Solutions',
      description: 'Specialized filtration systems and media designed to ensure clean water, gas purity, and equipment efficiency in restaurants, cafés, beverage production, and food processing environments. Focus on water filtration, beverage quality, equipment protection, and food safety.',
      challenges: [
        'Scale buildup in equipment',
        'Chlorine affecting taste and causing corrosion',
        'Sediment clogging systems and media and nozzles',
        'Biofilm growth in ice machines',
        'Maintaining consistent beverage quality',
      ],
      technologies: [
        { name: 'Carbon Dioxide Purification', use: 'Purifying CO₂ for carbonated drinks, removing trace contaminants, ensuring beverage quality and safety' },
        { name: 'Ice Machine Filtration', use: 'Preventing scale buildup, biofilm growth, improving ice quality and extending equipment lifespan' },
        { name: 'Coffee/Hot Beverage Filtration', use: 'Scale reduction, improved taste, increased machine efficiency, preventing sediment clogging' },
        { name: 'Fountain Drinks Systems', use: 'Improving drink taste (postmix drinks are 83% water), preventing sediment damage and cloudiness' },
        { name: 'Drinking Water Filtration', use: 'Removing chlorine, sediment, VOCs, lead, and cysts for health safety and taste improvement' },
        { name: 'Steam/Combi Oven Filtration', use: 'Protecting expensive kitchen equipment using resin filtration and reverse osmosis (RO)' },
      ],
      caseExample: {
        title: 'Restaurant Chain Water Quality Enhancement',
        result: 'Improved beverage taste, 60% reduction in equipment maintenance costs',
      },
    },
    pharmaceutical: {
      name: 'Pharmaceutical & Chemical Industry',
      description: 'Ultra-pure filtration and separation solutions for pharmaceutical manufacturing, API production, and chemical processing, meeting stringent GMP and regulatory requirements.',
      challenges: [
        'Achieving pharmaceutical-grade purity',
        'Maintaining GMP compliance',
        'Validating filtration processes',
        'Preventing cross-contamination',
        'Ensuring batch consistency',
      ],
      technologies: [
        { name: 'Sterile Filtration', use: 'API purification and sterilization' },
        { name: 'Ultrafiltration', use: 'Protein and enzyme purification' },
        { name: 'Nanofiltration', use: 'Solvent recovery and concentration' },
        { name: 'Depth Filtration', use: 'Pre-filtration and clarification' },
      ],
      caseExample: {
        title: 'API Purification Enhancement',
        result: '99.99% sterility achieved, 50% validation time reduction',
      },
    },
    waterTreatment: {
      name: 'Water Treatment & Environmental',
      description: 'Advanced water purification, desalination, and wastewater treatment technologies for municipal, industrial, and environmental applications.',
      challenges: [
        'Meeting water quality standards',
        'Reducing operational costs',
        'Managing membrane fouling',
        'Treating diverse water sources',
        'Ensuring sustainable operations',
      ],
      technologies: [
        { name: 'Reverse Osmosis', use: 'Desalination and ultra-pure water' },
        { name: 'Ultrafiltration', use: 'Drinking water and wastewater treatment' },
        { name: 'Microfiltration', use: 'Pre-treatment and polishing' },
        { name: 'Nanofiltration', use: 'Water softening and contaminant removal' },
      ],
      caseExample: {
        title: 'Municipal Water Purification',
        result: 'Quality exceeds standards by 20%, 45% lower operating costs',
      },
    },
    mining: {
      name: 'Mining & Metallurgy Industry',
      description: 'Robust solid-liquid separation and process water treatment solutions for mining operations, mineral processing, and metal extraction industries.',
      challenges: [
        'Handling high solids content',
        'Processing abrasive materials',
        'Recovering valuable materials',
        'Treating process water',
        'Meeting environmental regulations',
      ],
      technologies: [
        { name: 'Filter Presses', use: 'Tailings dewatering and solid separation' },
        { name: 'Coarse Filtration', use: 'Process water pre-treatment' },
        { name: 'Membrane Filtration', use: 'Water recovery and reuse' },
        { name: 'Centrifugal Separation', use: 'High-capacity solid-liquid separation' },
      ],
      caseExample: {
        title: 'Tailings Water Recovery',
        result: '70% water recovery, reduced environmental impact',
      },
    },
    oilGas: {
      name: 'Oil & Gas Industry',
      description: 'High-performance filtration solutions for upstream, midstream, and downstream operations, including produced water treatment and product purification.',
      challenges: [
        'Handling harsh operating conditions',
        'Treating produced water',
        'Removing contaminants from products',
        'Protecting downstream equipment',
        'Meeting environmental standards',
      ],
      technologies: [
        { name: 'Coalescing Filtration', use: 'Oil-water separation' },
        { name: 'Membrane Filtration', use: 'Produced water treatment' },
        { name: 'Depth Filtration', use: 'Product purification' },
        { name: 'High-Pressure Filtration', use: 'Process stream treatment' },
      ],
      caseExample: {
        title: 'Produced Water Treatment',
        result: '95% water recovery, regulatory compliance achieved',
      },
    },
  },
};